define(function (require, exports) {
    'use strict';

    // @ngInject
    exports.numberDisplay = function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                name: '@',
                label: '@',
                maximum: '@',
                model: '='
            },
            link: function () { },
            template: '<div class="fixed-input">' +
            '   <div class="input-background"></div>' +
            '   <div class="number-input" ng-show="!edit" ng-click="editMe()">{{model | number : 2}}</div>' +
            '   <label ng-class="{filled: model!=null}">{{label}}</label>' +
            '</div>'
        };
    };

    // @ngInject
    exports.numberFormat = function () {
        return {
            require: '?ngModel',
            link: function (scope, elem, attrs, ctrl) {
                if (!ctrl) { return; }
                ctrl.$parsers.unshift(function (viewValue) {
                    var plainNumber = viewValue.replace(/[^,\.\d]?/g, '');
                    elem.val(plainNumber);
                    return plainNumber;
                });
                //Still there is some cases each 3 key strokes a letter can stay in the inbox, probably need to apply logic with $formatters also.
            }
        };
    };

    // @ngInject
    exports.maxValue = function () {
        return {
            require: '?ngModel',
            link: function (scope, elem, attrs) {

                elem.bind('propertychange keyup paste', function () {
                    if (parseFloat(elem.context.value) > parseFloat(attrs.maxValue)) {
                        elem.parent().parent().addClass('greater');
                    } else {
                        elem.parent().parent().removeClass('greater');
                    }
                });
            }
        };
    };

});



// WEBPACK FOOTER //
// ./scripts/directives/metMandates/metMandates.js